import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DISPLAY_DATE_FORMAT } from '../../../common/constants/date-config';
import { ButtonAction } from '../../action-button/constants';
import { ActionButtonComponent } from '../../action-button';
import {
  TRANSPORTATION_TRACKING_DATES_CONFIG,
  TransportationTrackingActionType,
  TransportationTrackingAllTypesDatesModel,
  TransportationTrackingDateType,
} from '../transportation-tracking.constant';
import { LoadOverview, TransportOrderOverview } from '../../../store';
import { MaterialModule } from '../../../material.module';
import { DateWithTimezoneComponent } from '../../timezone/date-with-timezone.component';
import { DatesWithDividerComponent } from '../../dates-with-divider/dates-with-divider.component';
import { InfoFieldItemComponent } from '../../info-field/info-field-item/info-field-item.component';

@Component({
  selector: 'lib-transportation-tracking-dates-dialog',
  imports: [
    CommonModule,
    TranslateModule,
    MaterialModule,
    ActionButtonComponent,
    DateWithTimezoneComponent,
    DatesWithDividerComponent,
    InfoFieldItemComponent,
  ],
  templateUrl: './transportation-tracking-dates-dialog.component.html',
  styleUrls: ['./transportation-tracking-dates-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportationTrackingDatesDialogComponent {
  buttonAction = ButtonAction;
  dateFormat = DISPLAY_DATE_FORMAT;
  transportationTrackingDateType = TransportationTrackingDateType;
  transportationTrackingActionType = TransportationTrackingActionType;

  dateFieldsConfig: TransportationTrackingAllTypesDatesModel;

  constructor(
    public dialogRef: MatDialogRef<TransportationTrackingDatesDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      actionType: TransportationTrackingActionType;
      overview: TransportOrderOverview | LoadOverview;
    },
  ) {
    this.dateFieldsConfig = TRANSPORTATION_TRACKING_DATES_CONFIG[data.actionType];
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
